import { socialMedia } from "../../utils/social-media";
import styles from "./social-media.module.css";
import Link from "next/link";

const SocialMedia = ({ dark }) => {
  const isDark = dark ?? false;
  // console.log(dark);
  return (
    <div className={`${styles.social_media} ${isDark ? styles.dark : ""}`}>
      {socialMedia.map((socmed) => (
        <div key={socmed.name}>
          <div>
            <Link
              href={socmed.url_path}
              target="_blank"
              aria-label={socmed.name}
              prefetch={false}
            >
              {socmed.icon}
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};
export default SocialMedia;
